import { AddComment, Visibility } from "@mui/icons-material";
import { Box, Divider, Typography } from "@mui/material";
import React from "react";

import { UseHandleKanban } from "0.Mine/1.Hooks/CRM/Kanban";
import {
  SafeArgonBox as ArgonBox,
  SafeArgonTypography as ArgonTypography,
  SafeArgonButton,
} from "0.Mine/4.Argon/ArgonComponents";

import { ActivityNote, NewNote } from "../sharedTypes";

import ActivityItem from "./ActivityItem";
import AddNoteDialog from "./AddNoteDialog";
import ViewAllActivitiesDialog from "./ViewAllActivityHistory";

interface ActivityHistoryProps {
  activities: ActivityNote[];
  isMobile: boolean;
  showAddNoteForm: boolean;
  showAllActivities: boolean;
  newNote: NewNote;
  leadName: string;
  setShowAddNoteForm: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAllActivities: React.Dispatch<React.SetStateAction<boolean>>;
  handleNoteInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddNote: () => void;
  setNewNote: React.Dispatch<React.SetStateAction<NewNote>>;
  analyzeActivities?: () => void;
}

const ActivityHistory: React.FC<ActivityHistoryProps> = ({
  activities,
  isMobile,
  showAddNoteForm,
  showAllActivities,
  newNote,
  leadName,
  setShowAddNoteForm,
  setShowAllActivities,
  handleNoteInputChange,
  handleAddNote,
  setNewNote,
  analyzeActivities,
}) => {
  return (
    <>
      <ArgonBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <ArgonTypography variant="h6" fontWeight="medium">
          Registro Attività
        </ArgonTypography>

        {/* Activity action buttons */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <SafeArgonButton
            variant="contained"
            color="primary"
            size={isMobile ? "small" : "medium"}
            startIcon={<AddComment />}
            onClick={() => setShowAddNoteForm(true)}
          >
            {isMobile ? "Aggiungi" : "Aggiungi Note"}
          </SafeArgonButton>

          <SafeArgonButton
            variant="outlined"
            color="primary"
            size={isMobile ? "small" : "medium"}
            startIcon={<Visibility />}
            onClick={() => setShowAllActivities(true)}
          >
            {isMobile ? "Vedi" : "Vedi tutto"}
          </SafeArgonButton>
        </Box>
      </ArgonBox>

      <Divider sx={{ my: 1.5 }} />

      {/* Display most recent activities */}
      {activities.length > 0 ? (
        activities
          .slice(0, 3)
          .map((activity) => <ActivityItem key={activity.id} activity={activity} />)
      ) : (
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ my: 4 }}>
          Nessuna attività registrata
        </Typography>
      )}

      {/* Dialogs */}
      <AddNoteDialog
        open={showAddNoteForm}
        onClose={() => setShowAddNoteForm(false)}
        newNote={newNote}
        handleNoteInputChange={handleNoteInputChange}
        handleAddNote={handleAddNote}
        setNewNote={setNewNote}
        analyzeActivities={analyzeActivities}
      />

      <ViewAllActivitiesDialog
        open={showAllActivities}
        onClose={() => setShowAllActivities(false)}
        activities={activities}
        leadName={leadName}
      />
    </>
  );
};

export default ActivityHistory;
